module.exports = __webpack_public_path__ + "img/patch-plus-fill.07033dc2.svg";